import { StorefrontPlugins } from '@engyalo/storefront-types'
// import { Grid } from '@chakra-ui/core'
// import { SomePlugin } from './plugins/SomePlugin'

export const plugins = {
  // Catalogue: {
  //     container: Grid,
  //     props: {
  //         gridTemplateColumns: '1fr',
  //     },
  // },
  // CollectionProduct: {
  //     container: SomePlugin,
  // },
} as StorefrontPlugins
